import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

// BUG: Angular life cycle hooks are not called automatically in prod. Must be called manually by inheriting directives.
export default abstract class ReactRenderer implements OnInit, OnDestroy {
    public onRenderPromise: Promise<void>;

    private rendered = false;
    private destroyed = false;

    constructor(public target: ElementRef) {}

    public ngOnInit() {
        // BUG: ngOnInit/ngOnDestroy are not called automatically in prod. Must be called manually by inheriting directives.
        this.render();
    }

    public render() {
        this.onRenderPromise = new Promise(resolve => {
            if (!React || !ReactDOM) {
                resolve();
                return;
            }
            const fetchElement = this.getReactElement();
            fetchElement.then(element => !this.destroyed && (this.rendered = true, ReactDOM.render(element, this.target.nativeElement, resolve)));
        });
        return this.onRenderPromise;
    }

    public async abstract getReactElement(): Promise<React.ReactElement<{}>>;

    public ngOnDestroy() {
        // BUG: ngOnInit/ngOnDestroy are not called automatically in prod. Must be called manually by inheriting directives.
        if (!React || !ReactDOM) {
            return;
        }

        this.destroyed = true;
        this.rendered &&
            ReactDOM.unmountComponentAtNode(this.target.nativeElement);
    }
}
